import { useSelector } from 'react-redux';
import { getApplication } from 'views/manager/views/hr/views/applications/ApplicationsSelectors';

export const useApplication = () => {
    const application = useSelector(getApplication);
    return { application };
};
